import { IconName } from "@/shared/ui/Icon";

interface BreadcrumbItemProps {
  label: string;
  icon?: IconName;
  path?: string;
  options?: BreadcrumbItemProps[];
}

export default {
  myProfile: {
    label: "user.my_profile",
    icon: "User" as IconName,
    path: "/profile",
  },
  teams: {
    label: "feature.teams",
    icon: "Users" as IconName,
    path: "/teams",
  },
  scorecards: {
    label: "feature.scorecards",
    icon: "Clipboard" as IconName,
    path: "/scorecards",
  },
  projects: {
    label: "feature.projects",
    icon: "Projects" as IconName,
    path: "/projects",
  },
};
